var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("C:/Users/kaharmanny/source/repos/rentmagic.frontend/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["views/login.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div>\r\n\t<div class=\"box pull-center\">\r\n\t\t<form method=\"post\">\r\n\t\t\t<div class=\"logo\">\r\n\t\t\t\t<span class=\"logo-icon infodatek-icon infodatek-icon-";
output += runtime.suppressValue(env.getFilter("lower").call(context, runtime.contextOrFrameLookup(context, frame, "product")), env.opts.autoescape);
output += "\"></span><br>\r\n\t\t\t\t<span class=\"logo-text\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "product"), env.opts.autoescape);
output += "</span>\r\n\t\t\t</div>\r\n\r\n\t\t\t<div class=\"spinner pull-center ";
output += runtime.suppressValue((!runtime.contextOrFrameLookup(context, frame, "loading")?"hide":""), env.opts.autoescape);
output += "\"></div><br>\r\n\r\n\t\t\t";
if(!runtime.contextOrFrameLookup(context, frame, "active")) {
output += "\r\n\t\t\t<div class=\"form-element\">\r\n\t\t\t\t<select name=\"language\">\r\n\t\t\t\t\t";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "languages");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("lang", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\r\n\t\t\t\t\t<option value=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"ID"), env.opts.autoescape);
output += "\" ";
output += runtime.suppressValue((runtime.memberLookup((t_4),"ID") == runtime.contextOrFrameLookup(context, frame, "language")?"selected":""), env.opts.autoescape);
output += ">";
output += runtime.suppressValue(runtime.memberLookup((t_4),"Name"), env.opts.autoescape);
output += "</option>\r\n\t\t\t\t\t";
;
}
}
frame = frame.pop();
output += "\r\n\t\t\t\t</select>\r\n\t\t\t</div>\r\n\t\t\t";
;
}
output += "\r\n\r\n\t\t\t";
if(runtime.contextOrFrameLookup(context, frame, "err")) {
output += "\r\n\t\t\t<div class=\"error-box\">";
output += runtime.suppressValue((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "err")),"data") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "err")),"data")),"Data") && runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "err")),"data")),"Data")),"Translation")?runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "err")),"data")),"Data")),"Translation"):runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "err")),"message")), env.opts.autoescape);
output += "</div>\r\n\t\t\t";
;
}
output += "\r\n\t\t\t\r\n\t\t\t";
if(runtime.contextOrFrameLookup(context, frame, "screen") == runtime.contextOrFrameLookup(context, frame, "null")) {
output += "\r\n\t\t\t<div class=\"form-element\">\r\n\t\t\t\t<input type=\"text\" name=\"username\" placeholder=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"UserName"), env.opts.autoescape);
output += "\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "form")),"username") || runtime.contextOrFrameLookup(context, frame, "username"), env.opts.autoescape);
output += "\" ";
output += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "active")?"disabled":""), env.opts.autoescape);
output += ">\r\n\t\t\t</div>\r\n\r\n\t\t\t<div class=\"form-element with-side\">\r\n\t\t\t\t<div class=\"show-password material-icons\">&#xe8f4;</div>\r\n\t\t\t\t<input type=\"password\" name=\"password\" placeholder=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"Password"), env.opts.autoescape);
output += "\">\r\n\t\t\t</div>\r\n\r\n\t\t\t";
if(runtime.contextOrFrameLookup(context, frame, "err") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "err")),"data") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "err")),"data")),"Users")) {
output += "\r\n\t\t\t<div class=\"form-element\">\r\n\t\t\t\t<select name=\"kick\">\r\n\t\t\t\t";
frame = frame.push();
var t_7 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "err")),"data")),"Users");
if(t_7) {var t_5;
if(runtime.isArray(t_7)) {
var t_6 = t_7.length;
for(t_5=0; t_5 < t_7.length; t_5++) {
var t_8 = t_7[t_5][0]
frame.set("id", t_7[t_5][0]);
var t_9 = t_7[t_5][1]
frame.set("desc", t_7[t_5][1]);
frame.set("loop.index", t_5 + 1);
frame.set("loop.index0", t_5);
frame.set("loop.revindex", t_6 - t_5);
frame.set("loop.revindex0", t_6 - t_5 - 1);
frame.set("loop.first", t_5 === 0);
frame.set("loop.last", t_5 === t_6 - 1);
frame.set("loop.length", t_6);
output += "\r\n\t\t\t\t\t<option value=\"";
output += runtime.suppressValue(t_8, env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(t_9, env.opts.autoescape);
output += "</option>\r\n\t\t\t\t";
;
}
} else {
t_5 = -1;
var t_6 = runtime.keys(t_7).length;
for(var t_10 in t_7) {
t_5++;
var t_11 = t_7[t_10];
frame.set("id", t_10);
frame.set("desc", t_11);
frame.set("loop.index", t_5 + 1);
frame.set("loop.index0", t_5);
frame.set("loop.revindex", t_6 - t_5);
frame.set("loop.revindex0", t_6 - t_5 - 1);
frame.set("loop.first", t_5 === 0);
frame.set("loop.last", t_5 === t_6 - 1);
frame.set("loop.length", t_6);
output += "\r\n\t\t\t\t\t<option value=\"";
output += runtime.suppressValue(t_10, env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(t_11, env.opts.autoescape);
output += "</option>\r\n\t\t\t\t";
;
}
}
}
frame = frame.pop();
output += "\r\n\t\t\t\t</select>\r\n\t\t\t</div>\r\n\t\t\t";
;
}
else {
output += "\r\n\t\t\t<input type=\"hidden\" name=\"kick\" value=\"\">\r\n\t\t\t";
;
}
output += "\r\n\r\n\t\t\t<div class=\"form-element\">\r\n\t\t\t\t<button class=\"button button-default login-button\" type=\"submit\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"LogIn"), env.opts.autoescape);
output += "</button>\r\n\t\t\t</div>\r\n\t\t\t\r\n\t\t\t<div class=\"form-element\">\r\n\t\t\t\t<button class=\"button button-menu ";
if(runtime.contextOrFrameLookup(context, frame, "canRegister")) {
output += " half ";
;
}
output += " password-lost-button\" type=\"submit\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"ForgotPassword"), env.opts.autoescape);
output += "</button>\r\n\t\t\t\t";
if(runtime.contextOrFrameLookup(context, frame, "canRegister")) {
output += "<button class=\"button button-menu half register-button\" type=\"submit\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"Register"), env.opts.autoescape);
output += "</button> ";
;
}
output += "\r\n\t\t\t</div>\r\n\t\t\t";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "screen") == "ResetPassword") {
output += "\r\n\t\t\t<div class=\"form-element with-side\">\r\n\t\t\t\t<div class=\"show-password material-icons\">&#xe8f4;</div>\r\n\t\t\t\t<input type=\"password\" name=\"password\" placeholder=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"Password"), env.opts.autoescape);
output += "\">\r\n\t\t\t</div>\r\n\r\n\t\t\t<div class=\"form-element with-side\">\r\n\t\t\t\t<div class=\"show-password material-icons\">&#xe8f4;</div>\r\n\t\t\t\t<input type=\"password\" name=\"confirmPassword\" placeholder=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"ConfirmPassword"), env.opts.autoescape);
output += "\">\r\n\t\t\t</div>\r\n\r\n\t\t\t<div class=\"form-element\">\r\n\t\t\t\t<button class=\"button button-default password-reset-button\" type=\"submit\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"ChangePassword"), env.opts.autoescape);
output += "</button>\r\n\t\t\t</div>\r\n\t\t\t";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "screen") == "ForgotPassword") {
output += "\r\n\t\t\t<p>";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"ForgotPasswordInfo"), env.opts.autoescape);
output += "</p>\r\n\r\n\t\t\t<div class=\"form-element\">\r\n\t\t\t\t<input type=\"text\" name=\"email\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "form")),"email"), env.opts.autoescape);
output += "\" placeholder=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"EmailAddress"), env.opts.autoescape);
output += "\">\r\n\t\t\t</div>\r\n\r\n\t\t\t<div class=\"form-element\">\r\n\t\t\t\t<button class=\"button button-menu half login-screen-return\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"Cancel"), env.opts.autoescape);
output += "</button>\r\n\t\t\t\t<button class=\"button button-default half password-request-button\" type=\"submit\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"Submit"), env.opts.autoescape);
output += "</button>\r\n\t\t\t</div>\r\n\t\t\t";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "screen") == "Register") {
output += "\r\n\t\t\t<p>";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"RegisterUserInfo"), env.opts.autoescape);
output += "</p>\r\n\t\t\t<div class=\"form-element\">\r\n\t\t\t\t<input type=\"text\" name=\"username\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "form")),"username"), env.opts.autoescape);
output += "\" placeholder=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"UserName"), env.opts.autoescape);
output += " \">\r\n\t\t\t</div>\r\n\t\t\t<div class=\"form-element\">\r\n\t\t\t\t<input type=\"text\" name=\"email\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "form")),"email"), env.opts.autoescape);
output += "\" placeholder=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"EmailAddress"), env.opts.autoescape);
output += " \">\r\n\t\t\t</div>\r\n\t\t\t<div class=\"form-element\">\r\n\t\t\t\t<input type=\"password\" name=\"password\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "form")),"password"), env.opts.autoescape);
output += "\" placeholder=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"Password"), env.opts.autoescape);
output += "\">\r\n\t\t\t</div>\r\n\t\t\t<div class=\"form-element\">\r\n\t\t\t\t<input type=\"password\" name=\"confirmPassword\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "form")),"confirmPassword"), env.opts.autoescape);
output += "\" placeholder=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"ConfirmPassword"), env.opts.autoescape);
output += "\">\r\n\t\t\t</div>\r\n\t\t\t<div class=\"form-element\">\r\n\t\t\t\t<button class=\"button button-menu half login-screen-return\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"Cancel"), env.opts.autoescape);
output += "</button>\r\n\t\t\t\t<button class=\"button button-default half register-send-button\" type=\"submit\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"Register"), env.opts.autoescape);
output += "</button>\r\n\t\t\t</div>\r\n\t\t\t";
;
}
;
}
;
}
;
}
output += "\r\n\t\t</form>\r\n\t</div>\r\n</div>\r\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["views/login.html"] , dependencies)